// extracted by mini-css-extract-plugin
module.exports = {"marketing-agreements__about-link":"_35O1d","marketing-agreements__about":"_110DC"};